export type ProjectGenerationMode = "standard" | "html" | "image";

export function projectGenerationPath(projectId: string, generationMode?: ProjectGenerationMode): string {
  const encodedProjectId = encodeURIComponent(projectId);
  const page = generationMode === "image" ? "image2-generating" : "generating";
  return `/app/projects/${encodedProjectId}/${page}`;
}
